import { useLocation } from 'react-router-dom';
import NavBar from '../Components/Main/NavBar';
import { useEffect } from 'react';

const PaymentReview = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: 'AW-17471145950/_u9ZCJaA3oUbEN6P8opB',
        value: params.get('TotalAmount') / 100,
        currency: 'HUF',
        transaction_id: params.get('ApprovalCode') || '',
      });
    }
  }, [params]); // dependency ensures correct updates

  const tranCode = params.get('TranCode');
  const status = tranCode === '000' ? 'Sikeres fizetés' : 'Sikertelen fizetés';

  let message;
  switch (tranCode) {
    case '000':
      message = 'A tranzakció jóváhagyva';
      break;
    case '101':
      message = 'A megadott kártyparaméterek érvénytelenek';
      break;
    case '105':
      message = 'A kibocsátó bank elutasította';
      break;
    case '116':
      message = 'Fedezet hiány';
      break;
    case '130':
      message = 'Limit túllépése';
      break;
    default:
      message = 'Sikertelen fizetés: Ismeretlen hiba';
      break;
  }

  return (
    <div>
      <NavBar />
      <div className="payment-review">
        <h1 className="text-2xl font-bold">{status}</h1>
        <ul className="payment-details">
          <li>Rendelés azonosító: {params.get('OrderID')}</li>
          <li>Fizetési mód: Bankkártya</li>
          <li>TranCode: {tranCode}, {message}</li>
          <li>Összeg: {params.get('TotalAmount') / 100} Ft</li>
          <li>Valuta: {params.get('Currency')}</li>
          <li>Bank jóváhagyási kód: {params.get('ApprovalCode')}</li>
          <li>Tranzakció időpontja: {params.get('PurchaseTime')}</li>
          <li>Kártya utolsó számjegyek: {params.get('ProxyPan')}</li>
        </ul>
      </div>
    </div>
  );
};

export default PaymentReview;
